import * as React from 'react';
import styled from 'styled-components';
import {
	globalHeaderZIndex,
	greyColour,
	whiteColour,
	newContentPadding,
	appHeaderWrapperHeightV2,
	tabletPortraitMinWidth,
	tabletLandscapeMinWidth,
	tabletLandscapePadding,
	phoneStatusBarHeight
} from '../../cssConstants';
import ProgressLine from './ProgressLine';
import LeftBlueOrWhiteIcon from './LeftBlueOrWhiteIcon';
import UserSocialProfileIcon from './UserSocialProfileIcon';

const Header = ({
	onBackButtonClick = undefined,
	headerText = '',
	networkUserProfileIconShown = false,
	currentStep = 0,
	totalStep = 0,
	colour = '',
	showProgressLine = false,
	rightAction
}: Props) => {
	const hasRightSideElement = networkUserProfileIconShown || !!rightAction;
	return (
		<>
			<HeaderWrapper>
				<BackButtonContainer>
					{onBackButtonClick && <LeftBlueOrWhiteIcon onClick={onBackButtonClick} />}
				</BackButtonContainer>
				{headerText && <HeaderText $hasIcon={hasRightSideElement}>{headerText}</HeaderText>}
				{networkUserProfileIconShown && <UserSocialProfileIcon />}
				{rightAction && <RightActionContainer>{rightAction}</RightActionContainer>}
			</HeaderWrapper>
			{showProgressLine && <HeaderProgressLine currentStep={currentStep} totalStep={totalStep} color={colour} />}
		</>
	);
};

export default Header;

interface Props {
	onBackButtonClick?: () => void;
	headerText?: string;
	networkUserProfileIconShown?: boolean;
	currentStep?: number;
	totalStep?: number;
	colour?: string;
	showProgressLine: boolean;
	rightAction?: React.ReactNode;
}

// Warning: Must update css constants if changing any height in this component: appHeaderWrapperHeightV2, appHeaderGap etc
const HeaderWrapper = styled.section`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	font-size: 14px;
	padding: ${phoneStatusBarHeight} 16px 5px 16px;
	z-index: ${globalHeaderZIndex};
	display: flex;
	align-items: center;
	background-color: ${whiteColour};

	@media (min-width: ${tabletLandscapeMinWidth}) {
		padding-left: ${tabletLandscapePadding};
		padding-right: ${tabletLandscapePadding};
	}
`;

const HeaderText = styled.h1<{ $hasIcon?: boolean }>`
	padding-right: ${(props) =>
		props.$hasIcon ? '0' : '30px'}; // Left arrow icon is 30px width, so add this padding to centre align header text
	width: 100%;
	text-align: center;
	font-size: 14px;
	font-weight: 500;
	letter-spacing: 0.1px;
	color: ${greyColour};
	white-space: nowrap; /* Prevents text from wrapping to a new line */
	overflow: hidden; /* Hides overflow content */
	text-overflow: ellipsis;

	@media (min-width: ${tabletPortraitMinWidth}) {
		font-size: 17px;
		padding-right: ${(props) =>
			props.$hasIcon ? '40px' : '70px'}; // Left arrow icon with 'Back' is 70px width, but when hasIcon only 40px
	}
`;

// Move the progress line inside the HeaderWrapper
const HeaderProgressLine = styled(ProgressLine)`
	position: fixed;
	top: ${appHeaderWrapperHeightV2}; // To set the position of progress line below the HeaderWrapper
	left: 0;
	width: 100%;
	z-index: ${globalHeaderZIndex};
	padding: 0 ${newContentPadding};

	.line-wrapper {
		margin-bottom: 0;
	}

	@media (min-width: ${tabletLandscapeMinWidth}) {
		padding-left: ${tabletLandscapePadding};
		padding-right: ${tabletLandscapePadding};
	}
`;

const BackButtonContainer = styled.div`
	width: 30px;
	height: 40px;

	@media (min-width: ${tabletPortraitMinWidth}) {
		width: 70px;
	}
`;

const RightActionContainer = styled.div`
	display: flex;
	align-items: center;
	flex-shrink: 0;
`;
